exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".commons--metaTitle--nV {\n  display: flex;\n}\n.commons--left--1q {\n  flex: 1;\n}\n.commons--right--5U {\n  opacity: 0.68;\n  font-weight: normal;\n  font-size: 14px;\n}\n", "",{"version":3,"sources":["list-item-meta-title.less"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB","file":"list-item-meta-title.less","sourcesContent":[".metaTitle {\n  display: flex;\n}\n.left {\n  flex: 1;\n}\n.right {\n  opacity: 0.68;\n  font-weight: normal;\n  font-size: 14px;\n}\n"]}]);

// Exports
exports.locals = {
	"metaTitle": "commons--metaTitle--nV",
	"left": "commons--left--1q",
	"right": "commons--right--5U"
};